module.exports = __webpack_public_path__ + "img/confirm9.d2b07a80.png";